import { Badge } from "./Badge";
import { Button } from "./Button";
import { Checkbox } from "./Checkbox";
import { CloseButton } from "./CloseButton";
import { Container } from "./Container";
import { CustomSelect } from "./CustomSelect";
import { Divider } from "./Divider";
import { FormLabel } from "./FormLabel";
import { Heading } from "./Heading";
import { Input } from "./Input";
import { Link } from "./Link";
import { Popover } from "./Popover";
import { Progress } from "./Progress";
import { Radio } from "./Radio";
import { RadioCard } from "./RadioCard";
import { Select } from "./Select";
import { Table } from "./Table";
import { Tabs } from "./Tabs";
import { Text } from "./Text";
import { Textarea } from "./Textarea";

export const components = {
  Badge,
  Button,
  Checkbox,
  CloseButton,
  Container,
  CustomSelect,
  Divider,
  FormLabel,
  Heading,
  Input,
  Link,
  Popover,
  Progress,
  Radio,
  RadioCard,
  Select,
  Table,
  Tabs,
  Text,
  Textarea,
};
